import React from 'react'

export const EditButton = () => {
    return (
        <>
            {/* <button type='button' className="btnEdit">
                Edit 
                <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.71979 6.0332L6.06645 1.68654C6.57979 1.1732 7.41979 1.1732 7.93312 1.68654L12.2798 6.0332" stroke="#666666" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button> */}
        </>
    )
}


